import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* setWeeksGoal(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setWeeksGoal',
        parameter: {
            userID: action.userID,
            date: action.date,
            weeksGoal: action.weeksGoal
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setWeeksGoal",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const setWeeksGoalSaga = takeEvery('SetWeeksGoal_Saga', setWeeksGoal);

function* getWeeksGoal(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getWeeksGoal',
        parameter: {
            userID: action.userID,
            date: action.date,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){

        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getWeeksGoal",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getWeeksGoalSaga = takeEvery('GetWeeksGoal_Saga', getWeeksGoal);

function* setIsLimitedSubjectSet(action) {
    yield put({
        type: "IsLimitedSubjectSet",
        isLimitedSubjectSet: action.isLimitedSubjectSet
    });
    yield put({
        type: "LoadEnd",
    });
}

export const setIsLimitedSubjectSetSaga = takeEvery('SetIsLimitedSubjectSet_Saga', setIsLimitedSubjectSet);